var React = require('react');

function Logo (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("clipPath",{"id":"_clipPath_qKcwcsQKZYcyCIhNUeM0k3YIj8gHNuSD"},React.createElement("rect",{"width":"300","height":"300"}))),React.createElement("g",{"clipPath":"url(#_clipPath_qKcwcsQKZYcyCIhNUeM0k3YIj8gHNuSD)","key":1},React.createElement("path",{"d":" M 179 238.975 L 151.5 266.425 L 87.5 202.425 L 115 174.975 L 179 238.975 Z  M 202.45 87.525 L 266.5 151.525 L 190.15 227.825 L 126.1 163.925 L 202.45 87.525 Z  M 191.1 76.325 L 76.3 191.225 L 33.5 148.575 L 148.4 33.575 L 191.1 76.325 Z ","fillRule":"evenodd","fill":"rgb(36,123,160)"}))]);
}

Logo.defaultProps = {"style":{"isolation":"isolate"},"viewBox":"0 0 300 300","width":"300","height":"300"};

module.exports = Logo;

Logo.default = Logo;
